module.exports = __webpack_public_path__ + "img/Lucky Hit Slots.1d83761a.png";